(function () {
  function normalizePath(path) {
    if (!path) return '/';
    return path.length > 1 ? path.replace(/\/+$/, '') : path;
  }

  function closeDrawer() {
    var drawer = document.getElementById('Details-menu-drawer-container');
    if (drawer && drawer.hasAttribute('open')) drawer.removeAttribute('open');
  }

  // Underline "Shop All" or "New Gear" in the menus when that is the page being viewed.
  function setCurrentNav() {
    try {
      if (!/\/collections\/all$/.test(normalizePath(window.location.pathname))) return;
      var newest = new URLSearchParams(window.location.search).get('sort_by') === 'created-descending';
      document.querySelectorAll('a[data-dd214-nav]').forEach(function (link) {
        var isNew = link.getAttribute('data-dd214-nav') === 'new';
        if (isNew === newest) link.setAttribute('aria-current', 'page');
      });
    } catch (e) {}
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[data-dd214-home-anchor]');
    if (!link) return;

    var targetId = link.getAttribute('data-dd214-home-anchor');
    var destination;
    try { destination = new URL(link.href, window.location.href); } catch (e) { return; }

    var sameHomePath = destination.origin === window.location.origin &&
      normalizePath(destination.pathname) === normalizePath(window.location.pathname);

    if (!sameHomePath) return;

    var target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    closeDrawer();

    window.requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + targetId);
      } else {
        window.location.hash = targetId;
      }
      var focusTarget = target.querySelector('h1,h2,input,button,a');
      if (focusTarget) {
        focusTarget.setAttribute('tabindex','-1');
        focusTarget.focus({preventScroll:true});
        window.setTimeout(function(){ focusTarget.removeAttribute('tabindex'); }, 1000);
      }
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setCurrentNav);
  else setCurrentNav();
})();
